import React from 'react'
import { connect } from 'react-redux'
import { addListItem, deleteListItem, nullDate, } from '../../public/utility'
import { doGetLeaveApply, doSaveLeaveApply, doDeleteLeaveApply } from '../../reducers/actions'
import { hasChangedValues, getFormValue, } from '../../public/utility/formValues'
import { doLeaveApplyAction } from '../../business/LeaveApplyAction'
class OutApply extends React.Component {
    state = {
        changedValues基本信息: {},
        id: this.props.match.params.id,
    }

    componentDidMount = () => {
        const { id } = this.state
        this.doGetLeaveApply(id)
    }
    componentWillUnmount = () => {
        this.unmount = true
    }
    doGetLeaveApply = (id) => {
        const { dispatch, checkRecordID, taskName } = this.props
        dispatch(doGetLeaveApply({
            id: id || 0,
            checkRecordID,
            taskName,
            onEnd: ({ errorMessage, initValues基本信息, initValues假期余额, initValues出差事由, optionsParas }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                } else {
                    this.setState({ id, initValues基本信息, initValues假期余额, initValues出差事由, changedValues出差事由: {}, changedValues基本信息: {}, optionsParas })
                }
            }
        }))
    }

    handlerSave = () => {
        const { dispatch, checkRecordID } = this.props
        const { id, changedValues基本信息, initValues基本信息, changedValues出差事由 } = this.state
        const values = { ...initValues基本信息, ...changedValues基本信息 }
        var newChangeValue = changedValues基本信息
        if (id == 0) {
            newChangeValue = {
                请假开始日期: values.请假开始日期,
                请假结束日期: values.请假结束日期,
                请假开始时段: values.请假开始时段,
                请假结束时段: values.请假结束时段,
                请假开始时间: values.请假开始时间,
                请假结束时间: values.请假结束时间,
                ...changedValues基本信息
            }
        }
        dispatch(doSaveLeaveApply({
            id,
            checkRecordID,
            changedValues基本信息: newChangeValue,
            changedValues出差事由,
            onEnd: ({ errorMessage, id }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                } else {
                    Ext.toast('保存成功')
                    this.setState({ id })
                    this.doGetLeaveApply(id)
                }
            }
        }))
    }

    handlerDelete = () => {
        const { dispatch, onSave } = this.props
        const { id } = this.state
        Tyan.pubForm.showConfirm('确定要删除？', () =>
            dispatch(doDeleteLeaveApply({
                id,
                onEnd: ({ errorMessage }) => {
                    if (errorMessage) {
                        Tyan.pubForm.showError(errorMessage)
                    }
                    else {
                        Ext.toast('删除成功')
                        onSave && onSave()
                        window.history.back()
                    }
                }
            })))
    }

    handelSubmit = (action, title) => {
        const { onSave, dispatch, showDetail } = this.props
        const { id } = this.state
        if (action == '请假申请.提交') {
            const 假勤项目 = getFormValue(this, '基本信息', '假勤项目')
            if (假勤项目 == '出差') {
                const { list } = Tyan.utility.getListItems(this, '出差事由', '出差事由')
                if (list.length == 0) {
                    Tyan.pubForm.showError('出差事由必须有一条')
                    return
                }
            }
        }
        doLeaveApplyAction(dispatch, title, { id: id, action: action, onSave: this.handlerClose, showDetail: showDetail })
    }

    handlerClose = () => {
        if (!this.bChanged()) {
            window.history.back()
            return
        }
        Tyan.pubForm.showConfirm('确定要放弃更改吗？', () => window.history.back())
    }

    handlerAddInfo = () => {
        addListItem(this, {}, '出差事由', '出差事由')
    }

    handlerDeleteInfo = (id) => {
        console.log('id', id)
        deleteListItem(this, '出差事由', '出差事由', id)
    }

    handleOutModeChange = (v) => {
        Tyan.doPostEvent({
            event: 'GetUnitName',
            data: {
                单位名称: v
            },
            onEnd: ({ errorMessage, optionsParas }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                    return
                }
            }
        })
    }

    handleChange = (v) => {
        const 员工编号 = getFormValue(this, '基本信息', '员工编号')
        const 员工姓名 = getFormValue(this, '基本信息', '员工姓名')
        Tyan.doPostEvent({
            event: 'GetVacationBalanceByPersonName',
            data: {
                员工编号,
                员工姓名,
                假勤项目: v
            },
            onEnd: ({ errorMessage, initValues假期余额 }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                    return
                }
                this.setState({ initValues假期余额 })
            }
        })
    }

    bChanged = () => {
        return hasChangedValues(this)
    }

    bSave = () => {
        const { initValues基本信息, changedValues基本信息, optionsParas } = this.state
        const values = { ...initValues基本信息, ...changedValues基本信息 }
        console.log('values', values)
        const 假勤项目 = values.假勤项目
        const 假期时段 = optionsParas['假期时段'][假勤项目]
        const 请假附件 = getFormValue(this, '基本信息', '请假附件')
        return hasChangedValues(this) && 假勤项目 &&
            (((假勤项目 == '公假' && values.服务单位 && values.是否产生误餐费) || (假勤项目 == '出差' && values.服务单位 && values.是否产生误餐费 && values.出行方式 && values.出差类别)) || (假勤项目 !== '公假' && 假勤项目 !== '出差')) &&
            ((假期时段 == '每天一时段' && values.请假开始日期 && values.请假结束日期 && values.请假开始时段 && values.请假结束时段) || (假期时段 == '连续时段' && values.请假开始时间 && values.请假结束时间)) &&
            values.职务代理人 && values.请假原因 && values.任务交接说明 &&
            ((请假附件.length > 0 && ['病假', '婚假', '丧假', '产假', '工伤假', '哺乳假'].indexOf(假勤项目) > -1) || ['病假', '婚假', '丧假', '产假', '工伤假', '哺乳假'].indexOf(假勤项目) == -1)
    }

    fieldset基本信息 = () => {
        const { initValues基本信息, changedValues基本信息, optionsParas } = this.state
        const { 状态名称, 超额请假时长, 是否申请人 } = initValues基本信息
        const { list: list出差事由 } = Tyan.utility.getListItems(this, '出差事由', '出差事由')

        const 假勤项目 = getFormValue(this, '基本信息', '假勤项目')
        const 职务代理人 = getFormValue(this, '基本信息', '职务代理人')
        const 司机确认时间 = getFormValue(this, '基本信息', '司机确认时间')
        const 假期时段 = optionsParas['假期时段'][假勤项目]
        const item = []
        if (超额请假时长 != null && 假勤项目 != null && 状态名称 != "请假申请" && 超额请假时长 > 0 && 假勤项目 == "事假") {
            item.push(
                {
                    _html: '', name: '超额请假时长文本', style: {
                        textAlign: 'left',
                        color: 'red',
                        fontSize: '12px',
                        lineHeight: 1,
                        fontWeight: 600,
                    }
                }
            )
        }
        item.push(
            {
                _group: '', disabled: 状态名称 !== '请假申请' || (状态名称 == '请假申请' && !是否申请人), margin: 0, padding: 0, items: [
                    { _text: '申请编号', disabled: true },
                    { _date: '创建日期', disabled: true },
                    { _text: '员工编号', disabled: true },
                    { _text: '员工姓名', disabled: true },
                    { _text: '部门名称', disabled: true },
                    { _text: '职务名称', disabled: true },
                    { _select: '职务代理人', editable: true, required: true, },
                    { _select: '假勤项目', required: true, onChange: (v) => this.handleChange(v), },
                    { _date: '请假开始日期', cdt: () => 假期时段 && 假期时段 == '每天一时段', required: true },
                    { _date: '请假结束日期', cdt: () => 假期时段 && 假期时段 == '每天一时段', required: true },
                    { _select: '请假开始时段', cdt: () => 假期时段 && 假期时段 == '每天一时段', required: true },
                    { _select: '请假结束时段', cdt: () => 假期时段 && 假期时段 == '每天一时段', required: true },

                    { _datetime: '请假开始时间', cdt: () => 假期时段 && 假期时段 == '连续时段', required: true },
                    { _datetime: '请假结束时间', cdt: () => 假期时段 && 假期时段 == '连续时段', required: true },

                    { _select: '服务单位', cdt: () => 假勤项目 && (假勤项目 == '公假' || 假勤项目 == '出差'), required: true, },
                    { _radio: '是否产生误餐费', cdt: () => 假勤项目 && (假勤项目 == '公假' || 假勤项目 == '出差') },
                    { _select: '出差类别', cdt: () => 假勤项目 && 假勤项目 == '出差', required: true, },

                    { _select: '出行方式', editable: true, forceSelection: false, cdt: () => 假勤项目 && 假勤项目 == '出差', required: true, },

                    { _text: '请假原因', maxRows: 3, required: true, cdt: () => 假勤项目 && 假勤项目 != '出差', },
                    { _text: '出差原因', name: '请假原因', maxRows: 3, required: true, cdt: () => 假勤项目 && 假勤项目 == '出差', },

                    { _text: '任务交接说明', required: true, maxRows: 3, cdt: () => 职务代理人 },
                    { _files: '出差报告', name: '出差报告', disabled: 状态名称 !== '报告中', cdt: () => 假勤项目 && 假勤项目 == '出差' && (状态名称 == '请假完成' || 状态名称 == '报告中') },
                    { _files: '附件', name: '请假附件', required: ['病假', '婚假', '丧假', '产假', '工伤假', '哺乳假'].indexOf(假勤项目) > -1, },
                    { _text: '备注', name: '请假备注', maxRows: 3, },

                    { _text: '车牌号码', cdt: () => 司机确认时间 && 司机确认时间 != nullDate, disabled: true, },
                    { _text: '驾驶员', cdt: () => 司机确认时间 && 司机确认时间 != nullDate, disabled: true, },]
            },
            {
                _group: '', disabled: 状态名称 !== '销假申请', hidden: 状态名称.indexOf('销假') == -1, margin: 0, padding: 0, items: [
                    { _text: '销假申请原因', maxRows: 3, },
                    { _files: '销假附件', name: '销假附件', minWidth: '95%' },
                    { _text: '销假备注', maxRows: 3, },
                ]
            },
            {
                _group: '', margin: 0, padding: 0, items: [].concat({
                    _buttons: [
                        { _button: '添加出差事由', icon: '', ui: '', margin: 0, handler: () => this.handlerAddInfo(), cdt: () => 状态名称 == '请假申请' && 假勤项目 == '出差' }
                    ], margin: 0, layout: { type: 'hbox', pack: 'end', align: 'center' }
                }).concat(list出差事由.map((o, iNo) => {
                    const _list = { listName: '出差事由', id: o.id }
                    return {
                        _border: `出差事由${iNo + 1}`, name: `出差事由[${o.id}]`, disabled: 状态名称 != '请假申请', list: _list, margin: '5 0 15 0', minWidth: '90%', fieldset: '出差事由', items: [
                            { _select: '单位名称', required: true, optionName: '单位名称', editable: true, forceSelection: false, flex: 2, },
                            { _select: '出行方式', required: true, optionName: '出行方式', },
                            { _date: '起日', required: true, },
                            { _date: '迄日', required: true, },
                            { _text: '城市', required: true, },
                            { _text: '出差记录', required: true, },
                            {
                                _buttons: [
                                    {
                                        _button: '删除', icon: 'trash-o', ui: 'decline', margin: 0,
                                        handler: () => Tyan.pubForm.showConfirm('确定要删除？', () => { this.handlerDeleteInfo(o.id) }), cdt: () => 状态名称 == '请假申请'
                                    }
                                ], margin: 0, layout: { type: 'hbox', pack: 'end', align: 'center' }
                            }
                        ]
                    }
                })
                )
            }
        )
        return item
    }

    fieldset流转日志 = () => {
        return [
            { _html: '', name: '流转日志', style: { textAlign: 'left' } }]
    }

    render() {
        const { showMessage: Message, showBody: Body } = this.props
        const { errorMessage, id, initValues基本信息, changedValues出差事由 } = this.state
        if (errorMessage) return Tyan.pubForm.showError(errorMessage)
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />
        const 假勤项目 = getFormValue(this, '基本信息', '假勤项目')
        const { 状态, 状态名称, 提交时间 } = initValues基本信息
        const bSubmit = this.bChanged()
        return <Body data={this} /* maxWidth="1100" */
            controls={
                [
                    { _button: 状态名称 == '请假申请' ? '提交' : '确认', icon: '', handler: () => this.handelSubmit(`${状态名称}.提交`, '提交'), cdt: () => id > 0 && (状态名称 == '请假申请' || !bSubmit && 状态名称 == '请假批准'), disabled: bSubmit || this.bSave() },
                    { _flow: 'OutApplyFlow', disabled: this.bSave(), cdt: () => id > 0, onFinish: () => window.history.back(), },
                    { _button: '销假申请', icon: '', handler: () => this.handelSubmit(`${状态名称}.销假申请`, '销假申请'), cdt: () => id > 0 && 假勤项目 !== '外训' && 状态名称 == '请假完成' && !bSubmit, disabled: bSubmit || this.bSave() },
                    { _button: '保存', icon: '', handler: this.handlerSave, disabled: !this.bSave(), cdt: () => 状态 == 1 || 状态名称 == '报告中' },
                    { _button: '删除', icon: '', ui: 'action decline alt', handler: this.handlerDelete, cdt: () => id > 0 && 状态 == 1 && 提交时间 == nullDate, disabled: this.bSave(), },
                    { _button: this.bChanged() && '取消' || '关闭', icon: '', handler: this.handlerClose },
                ]}
            fieldsets={
                [
                    { title: '请假申请', name: '基本信息', _fieldset: this.fieldset基本信息(), forceDisabled: 状态 == 3, docked: 'top', height: '68%', },
                    { title: '流转日志', name: '基本信息', _fieldset: this.fieldset流转日志(), fullblock: true },
                ]
            }
        />
    }
}

export default connect()(OutApply)